<template>
  <div>
    <pre>垂直排列且底部参差不齐</pre>
    <div class="masonry">
      <v-card
        v-for="item in 30"
        :id="item"
        :key="item"
        color="primary"
      >
        {{ item }}
      </v-card>
    </div>
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>
.masonry {
  columns: 6 200px;
  column-gap: 1rem;
  div {
    width: 150px;
    // background: #EC985A;
    color: white;
    margin: 0 1rem 1rem 0;
    display: inline-block;
    width: 100%;
    text-align: center;
    font-family: system-ui;
    font-weight: 900;
    font-size: 2rem;
  } 
  @for $i from 1 through 36 { 
    div:nth-child(#{$i}) {
      $h: (random(200) + 100) + px;
      height: $h;
      line-height: $h;
    }
  }
}

</style>